import * as React from 'react';
import { Note as NoteType } from '../../../../types/Note';
import { localedFormat } from '../../../../utils';
import './Note.css';
import { parseISO } from 'date-fns';
import Button from '../../../Button/Button';
import Input from '../../../Input/Input';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton/IconButton';
import MoreIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';

interface Props {
	note: NoteType;
	onEdit: (noteId: number, note: string) => Promise<boolean>;
	onDelete: (noteId: number) => Promise<boolean>;
}

const Note: React.FunctionComponent<Props> = props => {
	const [editMode, setEditMode] = React.useState(false);
	const inputRef = React.useRef<HTMLInputElement>(null);
	const [loading, setLoading] = React.useState(false);
	const [isDeleting, setDelete] = React.useState(false);
	const [menuOpen, setMenuOpen] = React.useState(false);

	const onEdit = () => {
		setLoading(true);

		props.onEdit(props.note.id, inputRef.current.value).then(result => {
			setLoading(false);
			setEditMode(false);
		})
	}
	
	const onDelete = () => {
		setDelete(true);
		setMenuOpen(false);

		props.onDelete(props.note.id);
	}

	const onEditHandler = () => {
		setEditMode(true);
		setMenuOpen(false);
	}

	const actionRef = React.useRef(null);

	return (
		<div className="note">
			<div className="note__text">
				{!editMode && props.note.note}

				<Collapse in={editMode}>
					<div>
						<Input
							defaultValue={props.note.note}
							inputRef={inputRef}
							hiddenLabel={true}
							multiline={true}
						/>

						<div className="note-edit__controls">
							<Button type="primary" isLoading={loading} onClick={onEdit}>
								Сохранить
							</Button>

							<Button onClick={() => setEditMode(false)}>Отменить</Button>
						</div>
					</div>
				</Collapse>

				<IconButton
					aria-controls={`note-action-${props.note.id}`}
					aria-haspopup="true"
					ref={actionRef}
					className="note__actions"
					onClick={() => setMenuOpen(true)}
				>
					<MoreIcon />
				</IconButton>

				<Menu
					open={menuOpen}
					id={`note-action-${props.note.id}`}
					anchorEl={actionRef.current}
					onClose={() => setMenuOpen(false)}
				>
					<MenuItem onClick={onEditHandler}>Редактировать</MenuItem>

					<MenuItem onClick={onDelete}>Удалить</MenuItem>
				</Menu>
			</div>

			<div className="note__date">
				<span>
					{localedFormat(parseISO(props.note.date as any), "dd MMMM yyyy")}
				</span>
			</div>
		</div>
	);
};

export default Note;
